import React, { useEffect, useState } from 'react';
import { Button, Space, Dropdown, Typography, Divider, Flex } from 'antd';
import { CaretDownFilled, EditOutlined, DeleteOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useParams, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import objectStore from '../../store/ObjectStore';
import equipmentStore from '../../store/EquipmentStore';
import ObjectModalForm from '../../components/Objects/ObjectModalForm';
import EquipmentModalForm from '../../components/equipment/EquipmentModalForm';
import EquipmentCard from '../../components/equipment/EquipmentCard';
import { openBitrixLink } from '../../utils/links';

const { Text } = Typography;

const ObjectPage = observer(() => {
  const { objectId } = useParams();
  const navigate = useNavigate();
  const object = objectStore.objects.find((c) => c.id === Number(objectId));
    useEffect(() => {
    equipmentStore.fetchEquipments();
  }, []);
  // States for object modal and equipment creation
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [equipmentModalOpen, setEquipmentModalOpen] = useState(false);

  const handleEditObject = () => setEditModalOpen(true);
  const handleDeleteObject = () => {objectStore.deleteObject(object?.id); navigate(-1)};

  const handleSaveObject = (updatedObject) => {
    if (!object) return;
    objectStore.updateObject(object.id, updatedObject);
    setEditModalOpen(false);
  };

  const handleAddEquipment = () => {
    setEquipmentModalOpen(true); // Только создание нового оборудования
  };

  const handleSaveEquipment = (newEquipment) => {
    setEquipmentModalOpen(false);
  };

  if (!object) return <div>Объект не найден</div>;

  return (
    <>
      <Space split={<Divider type="vertical" />} style={{ marginBottom: 20 }}>
        <Button
          type="text"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)}
        />
        <Dropdown
          placement="bottomRight"
          menu={{
            items: [
              {
                key: 'edit',
                icon: <EditOutlined />,
                label: 'Изменить',
                onClick: (e) => {
                  e.domEvent.stopPropagation();
                  handleEditObject();
                },
              },
              {
                key: 'delete',
                icon: <DeleteOutlined />,
                label: <span style={{ color: 'red' }}>Удалить</span>,
                onClick: (e) => {
                  e.domEvent.stopPropagation();
                  handleDeleteObject();
                },
              },
            ],
          }}
          trigger={['click']}
        >
          <Button
          type="text"
          onClick={(e) => e.stopPropagation()}
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: 0,
            maxWidth: 240,
            minWidth: 0, 
          }}
        >
          <Text
            ellipsis
            style={{
              flex: 1,
              minWidth: 0,
              fontWeight: 600,
              fontSize: 16,
              marginRight: 6,
            }}
          >
            {object.name}
          </Text>
          <CaretDownFilled />
          
        </Button>
        </Dropdown>
      </Space>

      <Flex style={{ marginBottom: 16, gap: 8 }}>
        {object.bitrixFolderLink && (
          <Button
            onClick={() => openBitrixLink(object.bitrixFolderLink)}
          >
            Открыть файлы
          </Button>
        )}
        <Button type="primary" onClick={handleAddEquipment}>
          Добавить оборудование
        </Button>
      </Flex>

      <Divider orientation="left">Оборудование</Divider>

      <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
        {equipmentStore.equipments
          .filter((item) => item.objectId === Number(objectId))
          .map((item) => (
            <EquipmentCard
              key={item.id}
              equipment={item}
              onClick={() =>
                navigate(`/objects/${objectId}/equipment/${item.id}`)
              }
            />
          ))}
      </Space>

      {/* Object modal */}
      <ObjectModalForm
        open={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        object={object}
        onSave={handleSaveObject}
      />

      {/* New equipment creation modal */}
      <EquipmentModalForm
        open={equipmentModalOpen}
        onClose={() => setEquipmentModalOpen(false)}
        objectId={objectId}
        onSave={handleSaveEquipment}
      />
    </>
  );
});

export default ObjectPage;
